import React from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { ThemeSwitcherProvider } from 'react-css-theme-switcher';
import store from './store';
import history from './history';
import Layouts from './layouts';
import { THEME_CONFIG } from './configs/AppConfig';
import './lang';
import { NavigationProvider } from 'context/navigationContext';
import { useSelector, useDispatch } from 'react-redux';
import { getLanguages } from 'store/selectors';
import { setLanguages } from 'store/slices/cacheSlice';
import { getConfigVariables } from 'store/slices/configVariableSlice';

const themes = {
	dark: `${process.env.PUBLIC_URL}/css/dark-theme.css`,
	light: `${process.env.PUBLIC_URL}/css/light-theme.css`,
};

const Initializer = () => {
	const languages = useSelector(getLanguages);
	const dispatch = useDispatch();

	const getAllLanguages = () => {
		dispatch(
			getConfigVariables({
				allRecords: true,
				type: 'language',
				sortBy: 'createdAt:desc',
			}),
		)
			.unwrap()
			.then((data) => {
				dispatch(setLanguages(data.result.data));
			});
	};

	React.useEffect(() => {
		if (!languages.length) {
			getAllLanguages();
		}
	}, []);

	return null;
};

function App() {
	return (
		<div className="App">
			<Provider store={store}>
				<NavigationProvider>
					<BrowserRouter history={history}>
						<ThemeSwitcherProvider themeMap={themes} defaultTheme={THEME_CONFIG.currentTheme} insertionPoint="styles-insertion-point">
							<Initializer />
							<Layouts />
						</ThemeSwitcherProvider>
					</BrowserRouter>
				</NavigationProvider>
			</Provider>
		</div>
	);
}

export default App;
